import { Button, Modal, ModalProps, theme } from "antd";
import * as React from "react";

import { ConfirmationTypeEnum } from "@/types";
import { CONFIRMATION_MODAL_TITLE } from "@/utils/constant";

interface ConfirmationModalProps extends ModalProps {
  type?: ConfirmationTypeEnum;
  title?: React.ReactNode;
  content?: React.ReactNode;
  cancelBtnText: string;
  okBtnText: string;
  loading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isHideActionButton?: boolean;
  actionButton?: React.ReactNode;
}

export const ConfirmationModal = ({
  open,
  type = ConfirmationTypeEnum.danger,
  title = CONFIRMATION_MODAL_TITLE,
  content,
  cancelBtnText,
  okBtnText,
  loading,
  onClose,
  onConfirm,
  isHideActionButton,
  actionButton,
}: ConfirmationModalProps) => {
  const { token } = theme.useToken();

  const btnColor = (() => {
    if (type === ConfirmationTypeEnum.success) {
      return token.colorSuccess;
    }

    if (type === ConfirmationTypeEnum.warning) {
      return token.colorWarning;
    }

    if (type === ConfirmationTypeEnum.danger) {
      return token.colorError;
    }
    if (type === ConfirmationTypeEnum.primary) {
      return token.colorPrimary;
    }
    return token.colorPrimary;
  })();

  return (
    <Modal
      open={open}
      centered
      footer={null}
      closable={false}
      onCancel={() => !loading && onClose()}
    >
      {title && <div className="text-2xl font-medium">{title}</div>}
      <div className="text-neutral-500">{content}</div>
      {!isHideActionButton && (
        <div className="mt-4 flex justify-end gap-x-2">
          <Button
            disabled={loading}
            onClick={() => !loading && onClose()}
            className="border border-neutral-400"
          >
            {cancelBtnText}
          </Button>
          {actionButton}
          <Button
            type="primary"
            loading={loading}
            onClick={onConfirm}
            style={{
              color: "#fff",
              backgroundColor: btnColor,
              boxShadow: "none",
            }}
          >
            {okBtnText}
          </Button>
        </div>
      )}
    </Modal>
  );
};
